import ContentContainer from '@components/ContentContainer';
import PDFViewer from '@components/PDFViewer';
import {
  useFileRevisionDownloadUrlQuery,
  useFileRevisionsQuery,
} from '@queries/file-revisions';
import { useSourceQuery } from '@queries/sources';
import { useSourceId } from '@utils/router';

const TeamSourcePreviewPage = () => {
  const sourceId = useSourceId();

  const sourceQuery = useSourceQuery(sourceId);
  const fileRevisionsQuery = useFileRevisionsQuery(
    { sourceIds: sourceId ? [sourceId] : [] },
    !!sourceId,
  );

  const fileRevisionUrlQuery = useFileRevisionDownloadUrlQuery(
    fileRevisionsQuery.data?.[0]?.fileRevisionId,
  );

  if (!sourceQuery.data) {
    return <ContentContainer.Loading />;
  }

  if (!sourceQuery.data.url || !fileRevisionUrlQuery.data) {
    return <ContentContainer.NotFound />;
  }

  return <PDFViewer url={fileRevisionUrlQuery.data.downloadUrl} />;
};

export default TeamSourcePreviewPage;
